export default {
  modal: 3,
  header: 2,
};
